import React, { useState } from 'react';
import Button from "../../assets/buttons/btnPrimary"
import ImgErrorC from '../../assets/images/no_connection.png'
import './errorconnection.css'

const Error = () => {
   
  return (
    <>
<div className='bodyerrorC'>
  <div className='errorCContainerContent'>
  <div className='errorCContainerText'>
    <p className='errorCTextOne'>Oops!</p>
    <h2 className='errorCTitle'>No connection</h2>
    <p className='errorCTextTwo'>Please check your internet connection</p>
    </div>
    <img src={ImgErrorC}  />
    </div>
 
<Button value="Refresh" styleClass="btnPrimary"/>
 
</div>
    </>
  );
};

export default Error;